const LEGACY_PREFIX = 'studio-editor-v2:assistant'
const PREFIX = 'studio-editor-v2:assistant:v2'
const MAX_MESSAGES = 20
const MAX_BYTES = 64 * 1024
const ROLES = ['user', 'assistant', 'generation', 'error']

export function assistantStorageKey(userId, adKey) {
  return `${PREFIX}:${String(userId || 'unknown')}:${String(adKey)}`
}

function legacyKey(key) {
  return key.startsWith(`${PREFIX}:`) ? `${LEGACY_PREFIX}:${key.slice(PREFIX.length + 1)}` : null
}

function clean(entry) {
  if (!entry || !ROLES.includes(entry.role)) return null
  if (['user', 'assistant', 'error'].includes(entry.role) && typeof entry.content !== 'string') return null
  return {
    id: String(entry.id || `${Date.now()}-${Math.random()}`),
    role: entry.role,
    content: typeof entry.content === 'string' ? entry.content : '',
    createdAt: entry.createdAt || null,
    changes: Array.isArray(entry.changes) ? entry.changes.filter((change) => typeof change === 'string').slice(0, 12) : [],
    followUp: typeof entry.followUp === 'string' ? entry.followUp : '',
    warnings: Array.isArray(entry.warnings) ? entry.warnings.filter((warning) => typeof warning === 'string').slice(0, 5) : [],
    status: typeof entry.status === 'string' ? entry.status : null,
    quality: typeof entry.quality === 'string' ? entry.quality : null,
  }
}

/**
 * The per-user, per-ad chat thread (20 messages, 64 KB). Version 2 stores typed messages —
 * user, assistant (intro, change bullets, follow-up), generation records and errors. A thread
 * saved by the previous drawer is read once and carried over.
 */
export function loadAssistantMessages(key) {
  const read = (storageKey) => {
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]')
      return Array.isArray(parsed) ? parsed.map(clean).filter(Boolean).slice(-MAX_MESSAGES) : []
    } catch {
      return []
    }
  }
  const current = read(key)
  if (current.length) return current
  const legacy = legacyKey(key)
  return legacy ? read(legacy) : []
}

export function saveAssistantMessages(key, messages) {
  const serializable = (messages || []).map(clean).filter(Boolean).slice(-MAX_MESSAGES)
  let payload = JSON.stringify(serializable)
  while (payload.length > MAX_BYTES && serializable.length > 2) {
    serializable.shift()
    payload = JSON.stringify(serializable)
  }
  try {
    localStorage.setItem(key, payload)
    const legacy = legacyKey(key)
    if (legacy) localStorage.removeItem(legacy)
  } catch {
    // Browser storage is a convenience; the assistant still works without it.
  }
}

export function removeAssistantMessages(key) {
  try {
    localStorage.removeItem(key)
    const legacy = legacyKey(key)
    if (legacy) localStorage.removeItem(legacy)
  } catch {
    // Ignore unavailable browser storage.
  }
}
